const maskCharacter = (str: string, mask: string, n = 1) => {
  // Slice the string and replace with
  // mask then add remaining string
  return ('' + str).slice(0, 1) + ('' + '*******') + ('' + str).slice(-n);
};
export default maskCharacter;
